/* import { IoInformationCircle } from "react-icons/io5"; */

import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import {
  BrowserRouter,
  Switch,
  Route,
  Link,
  useLocation,
  useParams,
  useHistory,
} from "react-router-dom";
import {
  Container,
  Button,
  ThemeProvider,
  Form,
  Row,
  Col,
} from "react-bootstrap";

import { Worker, LocalizationContext } from "@react-pdf-viewer/core";

// Import the main component
import { Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { fullScreenPlugin } from "@react-pdf-viewer/full-screen";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { scrollModePlugin } from "@react-pdf-viewer/scroll-mode";
import { ScrollMode } from "@react-pdf-viewer/scroll-mode";
import {
  selectionModePlugin,
  SelectionMode,
} from "@react-pdf-viewer/selection-mode";
import { searchPlugin } from "@react-pdf-viewer/search";

import { bookmarkPlugin } from "@react-pdf-viewer/bookmark";

// Import styles
import "@react-pdf-viewer/search/lib/styles/index.css";
import "@react-pdf-viewer/scroll-mode/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/thumbnail/lib/styles/index.css";
import "@react-pdf-viewer/selection-mode/lib/styles/index.css";
import "@react-pdf-viewer/bookmark/lib/styles/index.css";

import Intro from "./Intro";
import viewerLocalizationAr from "./viewerLocalizationAr";
import usePageMeta from "./usePageMeta";

const SHEET_ENDPOINT =
  "https://0fhdyyj31k.execute-api.us-east-2.amazonaws.com/default/aleimansheet";
const SIGN_URL_ENDPOINT =
  "https://3d1qba27pl.execute-api.us-east-2.amazonaws.com/default/signURL";
const CONTACT_ENDPOINT =
  "https://d94e0mxye5.execute-api.us-east-2.amazonaws.com/Prod/send";

/*
 * The toolbar buttons are rendered outside <Viewer>, so the Viewer's own
 * `localization` prop never reaches them — they kept their English labels.
 * Providing the context around both the toolbar and the viewer localises
 * everything. Defined at module scope so the context value stays referentially
 * stable across renders.
 */
const localizationValue = {
  l10n: viewerLocalizationAr,
  setL10n: () => {},
};

/*
 * The PDF bucket's CORS policy only allows the production origin, so a signed
 * URL fetched from http://localhost:3000 is blocked by the browser. In
 * development, drop the origin and request the path instead: the dev server
 * proxies it to the bucket (see the "proxy" field in package.json), which keeps
 * the request same-origin. Production is untouched.
 */
function toFetchableUrl(signedUrl) {
  if (process.env.NODE_ENV !== "development") {
    return signedUrl;
  }
  const parsed = new URL(signedUrl);
  return parsed.pathname + parsed.search;
}

//var myHeaders = new Headers();

/* var sheetdata = require("./data.js"); */

var gSheet = [];

// Shown in the footer; the index is the source of truth for the real count.
const TOTAL_ISSUES_LABEL = "٣٢٨";

function App() {
  const [loading, setLoading] = useState(true);
  const [indexFailed, setIndexFailed] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  /*
   * Fetch the issue list once, with retries.
   *
   * Two problems this addresses. It used to depend on `loading` while also
   * setting it, so the 71 KB list was re-downloaded on every page view. And the
   * endpoint reads a Google Sheet on every call: it takes 2–4 seconds and
   * intermittently returns 500. Previously a single 500 was only logged to the
   * console, which left `loading` true and the entire site on a spinner with no
   * message and no way to recover.
   */
  useEffect(() => {
    let cancelled = false;

    async function loadIndex() {
      const attempts = 3;

      for (let attempt = 1; attempt <= attempts; attempt++) {
        try {
          const response = await fetch(SHEET_ENDPOINT, {
            method: "GET",
            redirect: "follow",
          });
          if (!response.ok) {
            throw new Error("index request returned " + response.status);
          }
          const result = await response.json();
          if (cancelled) {
            return;
          }
          gSheet = result;
          setIndexFailed(false);
          setLoading(false);
          return;
        } catch (error) {
          console.error(
            "Could not load the issue index (attempt " + attempt + ")",
            error
          );
          if (attempt < attempts && !cancelled) {
            await new Promise((resolve) => setTimeout(resolve, 600 * attempt));
          }
        }
      }

      if (!cancelled) {
        setIndexFailed(true);
      }
    }

    setIndexFailed(false);
    loadIndex();

    return () => {
      cancelled = true;
    };
  }, [retryCount]);

  const testStyle = {
    visibility: "hidden",
    display: "none",
  };

  return (
    <div className="main" dir="rtl">
      <ThemeProvider dir="rtl">
        <div style={testStyle}>test</div>

        <BrowserRouter>
          <SiteHeader />

          {/* Replaces the routes rather than sitting above them: without the
              issue list every page would otherwise show its own spinner
              underneath this message. */}
          {indexFailed ? (
            <div className="issueStatus" role="alert">
              <p className="issueStatusTitle">تعذّر تحميل فهرس الأعداد</p>
              <p>
                لم نتمكّن من الوصول إلى قائمة الأعداد. قد تكون المشكلة مؤقتة.
              </p>
              <div className="issueStatusActions">
                <button
                  className="btnPrimary"
                  type="button"
                  onClick={() => setRetryCount((count) => count + 1)}
                >
                  إعادة المحاولة
                </button>
              </div>
            </div>
          ) : (
          <Switch>
            <Route path="/browse">
              <Browse loading={loading} />
            </Route>

            <Route path="/contact">
              <Contact />
            </Route>

            <Route path="/search">
              <Search />
            </Route>

            <Route path="/issue/:id">
              <Issue loading={loading} />
            </Route>

            <Route exact path="/">
              <Home loading={loading} />
            </Route>

            <Route path="*">
              <NoMatch />
            </Route>
          </Switch>
          )}
          <SiteFooter />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;

/*
 * Masthead and navigation, per the redesign: a thin accent bar carrying the
 * paper's standing line, then the title and tagline, then the nav rail.
 */
function SiteHeader() {
  const { pathname } = useLocation();
  const isActive = (path) =>
    path === "/" ? pathname === "/" : pathname.startsWith(path);

  // The full masthead belongs on the home page. On the reader in particular it
  // would push the page image below the fold, so inner routes get a condensed
  // version and the reader drops the standing line as well.
  const isHome = pathname === "/";
  const isReader = pathname.startsWith("/issue/");

  return (
    <>
      {!isReader && (
        <div className="eyebrowBar">
          <span className="star" aria-hidden="true">
            ✷
          </span>
          أول صحيفة صدرت في اليمن · سنة ١٣٤٥هـ
          <span className="star" aria-hidden="true">
            ✷
          </span>
        </div>
      )}

      <header className={"masthead" + (isHome ? "" : " isCompact")}>
        <h1 className="mastheadTitle">
          <Link to="/">جريدة الإيمان</Link>
        </h1>
        {isHome && (
          <>
            <p className="mastheadTagline">اقرأ اليمن كما كُتبت قبل مئة عام</p>
            <div className="betaNotice">تشغيل تجريبي</div>
          </>
        )}
      </header>

      <nav className="mainNav" aria-label="التنقل الرئيسي">
        <Link to="/" className={isActive("/") ? "isActive" : undefined}>
          الرئيسية
        </Link>
        <Link
          to="/browse"
          className={isActive("/browse") ? "isActive" : undefined}
        >
          تصفح الأرشيف
        </Link>
        <Link
          to="/contact"
          className={isActive("/contact") ? "isActive" : undefined}
        >
          التواصل
        </Link>
      </nav>
    </>
  );
}

function SiteFooter() {
  return (
    <footer className="siteFooter">
      <p style={{ margin: 0 }}>
        جريدة الإيمان — النسخة الرقمية · أرشيف {TOTAL_ISSUES_LABEL} عدد
      </p>
      <p style={{ margin: "0.4rem 0 0" }}>
        <Link to="/contact">للتواصل والملاحظات</Link>
      </p>
    </footer>
  );
}

/*
 * Dual-numbered issues: a single PDF covers two issue numbers. This replaces a
 * chain of fifteen hard-coded ternaries in the previous implementation.
 */
const DUAL_ISSUE_LABELS = {
  180: "١٨٠ و ١٨١",
  182: "١٨٢ و ١٨٣",
  219: "٢١٩ و ٢٢٠",
  221: "٢٢١ و ٢٢٢",
  223: "٢٢٣ و ٢٢٤",
  235: "٢٣٥ و ٢٣٦",
  239: "٢٣٩ و ٢٤٠",
  241: "٢٤١ و ٢٤٢",
  243: "٢٤٣ و ٢٤٤",
  245: "٢٤٥ و ٢٤٦",
  262: "٢٦٢ و ٢٦٣",
  269: "٢٦٩ و ٢٧٠",
  283: "٢٨٣ و ٢٨٤",
  292: "٢٩٢ و ٢٩٣",
};

function issueLabel(issue) {
  if (issue === "special") {
    return "عدد خاص";
  }
  return DUAL_ISSUE_LABELS[issue] || issue;
}

function Browse(props) {
  const [years, setYears] = useState([]);
  const [issues, setIssues] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  usePageMeta("جريدة الإيمان - تصفح الأرشيف");

  useEffect(() => {
    if (props.loading) {
      return;
    }
    setYears(gSheet[1].data);
    setIssues(gSheet[0].data);
    setActiveYear((current) => current || gSheet[1].data[0].yearno);
  }, [props.loading]);

  if (props.loading) {
    return (
      <div className="issueStatus" role="status" aria-live="polite">
        <div className="issueSpinner" aria-hidden="true" />
        <p>جارٍ تحميل فهرس الأعداد…</p>
      </div>
    );
  }

  const issuesFor = (yearno) =>
    issues.filter((entry) => entry.yearno + "" === yearno + "");

  const activeYearRow = years.find((y) => y.yearno + "" === activeYear + "");
  const activeIssues = issuesFor(activeYear);

  /*
   * Years 16–20 are absent from the index entirely. Deriving the gap from the
   * data rather than hard-coding it means the notice disappears on its own if
   * those years are ever added.
   */
  const yearNumbers = years.map((y) => Number(y.yearno)).sort((a, b) => a - b);
  const missingYears = [];
  for (let n = yearNumbers[0]; n < yearNumbers[yearNumbers.length - 1]; n++) {
    if (!yearNumbers.includes(n)) {
      missingYears.push(n);
    }
  }

  return (
    <div className="pageWrap">
      <div className="sectionHead">
        <h2>تصفح الأرشيف</h2>
      </div>

      <div className="timelineStrip">
        {years.map((y) => (
          <button
            key={"t" + y.yearno}
            type="button"
            data-active={y.yearno + "" === activeYear + "" ? "yes" : "no"}
            onClick={() => setActiveYear(y.yearno)}
          >
            {y.yearno}
          </button>
        ))}
      </div>

      <div className="browseFlex">
        <div className="yearRail" role="tablist" aria-label="سنوات الإصدار">
          {years.map((y) => (
            <button
              key={y.yearno}
              type="button"
              role="tab"
              aria-selected={y.yearno + "" === activeYear + ""}
              data-active={y.yearno + "" === activeYear + "" ? "yes" : "no"}
              onClick={() => setActiveYear(y.yearno)}
            >
              {y.year}
              <span className="railCount">({issuesFor(y.yearno).length})</span>
            </button>
          ))}
        </div>

        <div className="browseMain">
          {activeYearRow && (
            <div className="sectionHead">
              <h2>{activeYearRow.year}</h2>
            </div>
          )}

          <div className="issueGrid">
            <Link
              className="issueCard indexCard"
              to={{ pathname: "/issue/" + activeYear + "_index" }}
            >
              <span className="cardLabel">فهرس</span>
              <span className="issueCardNumber">فهرس المقالات</span>
              <span className="issueCardNote">
                موضوعات هذه السنة مرتبة للوصول المباشر
              </span>
            </Link>

            {activeIssues.map((entry) => (
              <Link
                className="issueCard"
                key={entry.issue}
                to={{ pathname: "/issue/" + entry.issue }}
              >
                <span className="cardLabel">العدد</span>
                <span className="issueCardNumber">
                  {issueLabel(entry.issue)}
                </span>
                {entry.issuedate && (
                  <span className="issueCardDate">{entry.issuedate}</span>
                )}
              </Link>
            ))}
          </div>

          {missingYears.length > 0 && (
            <p className="issueCardNote" style={{ marginTop: "2rem" }}>
              ملاحظة: أعداد السنوات {missingYears.join("، ")} غير متوفرة في هذا
              الأرشيف.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function Home(props) {
  usePageMeta("جريدة الإيمان");

  const history = useHistory();
  const [query, setQuery] = useState("");

  const runSearch = (term) => {
    const trimmed = (term === undefined ? query : term).trim();
    if (!trimmed) {
      return;
    }
    history.push("/search?q=" + encodeURIComponent(trimmed));
  };

  return (
    <div>
      <section className="homeHero rise">
        <p className="homeHeroLede">
          كل أعداد جريدة الإيمان، مصوَّرة ومفهرسة، بين يديك.
        </p>

        <form
          className="homeSearchRow"
          onSubmit={(event) => {
            event.preventDefault();
            runSearch();
          }}
          role="search"
        >
          <input
            type="search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="ابحث في نصوص الأعداد والمقالات والأعلام…"
            aria-label="ابحث في نصوص الأعداد"
          />
          <button type="submit" className="btnPrimary">
            بحث
          </button>
        </form>

        <p className="searchHints">
          جرّب:
          {["صنعاء", "التعليم", "البن"].map((term) => (
            <button key={term} type="button" onClick={() => runSearch(term)}>
              {term}
            </button>
          ))}
        </p>
      </section>

      {props.loading && (
        <div className="issueStatus" role="status" aria-live="polite">
          <div className="issueSpinner" aria-hidden="true" />
          <p>جارٍ تحميل الأرشيف…</p>
        </div>
      )}

      {!props.loading && (
        <div className="pageWrap">
          <div className="sectionHead">
            <h2>ابدأ من هنا</h2>
          </div>

          <div className="cards3">
            <Link className="card" to="/issue/1">
              <span className="cardLabel">البداية</span>
              <span className="cardTitle">العدد الأول</span>
              <p className="cardBody">
                حيث بدأت الحكاية — أول عدد صدر سنة ١٣٤٥هـ.
              </p>
            </Link>
            <Link className="card" to="/browse">
              <span className="cardLabel">الأرشيف</span>
              <span className="cardTitle">تصفح الأعداد</span>
              <p className="cardBody">
                أربع وعشرون سنة مرتبة عددًا عددًا على خط زمني.
              </p>
            </Link>
            <Link className="card" to="/issue/1_index">
              <span className="cardLabel">للباحثين</span>
              <span className="cardTitle">فهرس المقالات</span>
              <p className="cardBody">
                فهرس موضوعي لكل سنة يوصلك إلى المقال مباشرة.
              </p>
            </Link>
          </div>

          <div className="sectionHead" style={{ marginTop: "3rem" }}>
            <h2>من فريق العمل</h2>
          </div>

          <div className="panel">
            <Intro data={gSheet[2].data} loading={props.loading} />
          </div>
        </div>
      )}
    </div>
  );
}

function Contact() {

  usePageMeta("جريدة الإيمان - التواصل");

  const [state, setstate] = useState({
    name: "",
    email: "",
    message: "",
    display: "none",
    hide: null,
    error: null,
  });
  const buttonRef = useRef(null);
  const thankYou = useRef("none");

  var handleChange = (e) => {
    setstate({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const sendMessage = async () => {
    buttonRef.current.disabled = true;

    // Deliberately does NOT send a recipient. This endpoint used to take
    // `toEmails` straight from the browser, which let anyone send mail to any
    // address through our sending identity. The recipient has to be decided
    // server-side; see the note in CONTACT_ENDPOINT_NOTES.md.
    //
    // Values are also sent as a form-encoded body rather than concatenated into
    // the query string: unencoded values broke on any "&" in a message, and a
    // query string puts names, addresses and message text into API Gateway and
    // CloudWatch logs.
    const body = new URLSearchParams({
      name: state.name,
      replyTo: state.email,
      message: state.message,
    });

    try {
      const response = await fetch(CONTACT_ENDPOINT, {
        method: "POST",
        redirect: "follow",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      if (!response.ok) {
        throw new Error("send returned " + response.status);
      }

      const result = await response.json();
      if (result === "Sent") {
        setstate({
          ...state,
          display: null,
          hide: "none",
          error: null,
        });
        return;
      }
      throw new Error("unexpected response: " + JSON.stringify(result));
    } catch (error) {
      console.error("Could not send the message", error);
      buttonRef.current.disabled = false;
      setstate({
        ...state,
        error: "تعذّر إرسال رسالتك. يرجى إعادة المحاولة.",
      });
    }
  };

  return (
    <div className="pageWrap">
      <div className="sectionHead">
        <h2>التواصل</h2>
      </div>
      <Form className="contactForm">
        <Container>
          <Row style={{ justifyContent: "center", display: state.display }}>
            <Col ref={thankYou} xs="11" lg="8">
              <p className="panel" style={{ textAlign: "center" }}>
                شكرا لتواصلكم مع جريدة الايمان. سوف نقوم بالرد عليكم عما قريب.
              </p>
            </Col>
          </Row>
          <Row style={{ justifyContent: "center", display: state.hide }}>
            <Col xs="10" lg="5">
              <Form.Group className="mb-3" controlId="contactName">
                <Form.Label>الاسم</Form.Label>
                <Form.Control
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  name="name"
                  type="name"
                  placeholder=""
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="contactEmail">
                <Form.Label>البريد الالكتروني</Form.Label>
                <Form.Control
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  name="email"
                  type="email"
                  placeholder="name@example.com"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="contactMessage">
                <Form.Label>الرسالة</Form.Label>
                <Form.Control
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  as="textarea"
                  name="message"
                  placeholder="محتوى الرسالة..."
                  rows={7}
                />
              </Form.Group>
            </Col>
          </Row>
          {state.error && (
            <Row style={{ justifyContent: "center" }}>
              <Col xs="10" lg="5">
                <p role="alert" className="formError">
                  {state.error}
                </p>
              </Col>
            </Row>
          )}
          <Row style={{ justifyContent: "center", display: state.hide }}>
            <Col xs="10" lg="5">
              <button
                className="btnPrimary"
                type="button"
                ref={buttonRef}
                onClick={() => {
                  sendMessage();
                }}
              >
                إرسال
              </button>
            </Col>
          </Row>
        </Container>
      </Form>
    </div>
  );
}

function Issue(props) {
  let { id } = useParams();
  // "loading" | "ready" | "error" — the viewer used to show 0% forever on
  // failure because the only error handling was a console.log.
  const [status, setStatus] = useState("loading");
  const [pdfObjectUrl, setPdfObjectUrl] = useState(null);
  const [progress, setProgress] = useState(0);
  const [retryCount, setRetryCount] = useState(0);
  const [next, setNext] = useState("/browse");
  const [prev, setPrev] = useState("/browse");
  const [menuA, setMenueA] = useState("hide");

  // These factories call Hooks internally, so they must be invoked directly in
  // the component body — wrapping them in useMemo breaks the Hook call order.
  const zoomPluginInstance = zoomPlugin();
  const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;

  const fullScreenPluginInstance = fullScreenPlugin();
  const { EnterFullScreenButton } = fullScreenPluginInstance;

  const scrollModePluginInstance = scrollModePlugin({
    scrollMode: ScrollMode.Vertical,
  });
  const { SwitchScrollModeButton } = scrollModePluginInstance;

  // Was previously the string "SelectionMode.Hand", which is not a valid enum
  // value, so the requested hand tool was never actually applied. Switch to
  // SelectionMode.Text if researchers should be able to select text.
  const selectionModePluginInstance = selectionModePlugin({
    selectionMode: SelectionMode.Hand,
  });

  // Previously searched for the keyword "PDF" on every open, which highlighted
  // nothing useful in an Arabic newspaper.
  const searchPluginInstance = searchPlugin();
  const { ShowSearchPopoverButton } = searchPluginInstance;

  const bookmarkPluginInstance = bookmarkPlugin();
  const { Bookmarks } = bookmarkPluginInstance;

  const plugins = [
    zoomPluginInstance,
    fullScreenPluginInstance,
    scrollModePluginInstance,
    selectionModePluginInstance,
    searchPluginInstance,
    bookmarkPluginInstance,
  ];

  usePageMeta("جريدة الإيمان - العدد " + id);

  // Previous / next links come from the issue index, which is a separate
  // concern from loading the PDF itself.
  useEffect(() => {
    if (props.loading) {
      return;
    }

    const details = gSheet[0].data;
    const match = details.find((entry) => entry.issue + "" === id);

    setPrev(match && match.prev ? "/issue/" + match.prev : "/browse");
    setNext(match && match.next ? "/issue/" + match.next : "/browse");
  }, [id, props.loading]);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;

    setStatus("loading");
    setPdfObjectUrl(null);
    setProgress(0);

    async function loadIssue() {
      try {
        const signResponse = await fetch(
          SIGN_URL_ENDPOINT + "?issue=" + encodeURIComponent(id),
          { method: "GET", redirect: "follow" }
        );
        if (!signResponse.ok) {
          throw new Error("signURL returned " + signResponse.status);
        }
        const signedUrl = await signResponse.json();

        // The signed URL currently expires after 5 seconds, so download the
        // file straight away instead of handing that URL to the viewer and
        // racing the expiry — mounting plus worker startup routinely loses that
        // race, which left the reader empty with no explanation.
        const pdfResponse = await fetch(toFetchableUrl(signedUrl));
        if (!pdfResponse.ok) {
          throw new Error("PDF request returned " + pdfResponse.status);
        }

        /*
         * Report real download progress.
         *
         * Downloading the whole file before the viewer sees any of it is the
         * price of the five-second signed URL: pdf.js would otherwise stream
         * the document and paint page one early, but it cannot re-request an
         * expired URL. Until the expiry is raised server-side, the least we can
         * do is show how far along the download is instead of an indeterminate
         * spinner. Raising the expiry would let us hand the URL straight to the
         * viewer and get progressive rendering back.
         */
        const total = Number(pdfResponse.headers.get("content-length")) || 0;
        let blob;

        if (total > 0 && pdfResponse.body && pdfResponse.body.getReader) {
          const reader = pdfResponse.body.getReader();
          const chunks = [];
          let received = 0;

          while (true) {
            const { done, value } = await reader.read();
            if (done) {
              break;
            }
            chunks.push(value);
            received += value.length;
            if (!cancelled) {
              setProgress(Math.min(100, Math.round((received / total) * 100)));
            }
          }
          blob = new Blob(chunks, { type: "application/pdf" });
        } else {
          blob = await pdfResponse.blob();
        }

        if (blob.size === 0) {
          throw new Error("PDF for issue " + id + " is empty");
        }

        if (cancelled) {
          return;
        }

        // A blob URL rather than the raw bytes: pdf.js transfers an ArrayBuffer
        // to its worker, which detaches it, so any later re-render that
        // retriggers a load would silently fail. A blob URL can be read as many
        // times as needed and never expires.
        objectUrl = URL.createObjectURL(blob);
        setPdfObjectUrl(objectUrl);
        setStatus("ready");
      } catch (error) {
        if (cancelled) {
          return;
        }
        console.error("Could not load issue " + id, error);
        setStatus("error");
      }
    }

    loadIssue();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [id, retryCount]);

  var menuAct = (h) => {
    if (h) {
      setMenueA("hide");
    } else if (menuA === "hide") {
      setMenueA("show");
    } else {
      setMenueA("hide");
    }
  };

  return (
    <div>
      {status === "loading" && (
        <div className="issueStatus" role="status" aria-live="polite">
          <div className="issueSpinner" aria-hidden="true" />
          <p>جارٍ تحميل العدد {id}…</p>
          {progress > 0 && (
            <div
              className="issueProgress"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              <div
                className="issueProgressBar"
                style={{ width: progress + "%" }}
              />
            </div>
          )}
        </div>
      )}

      {status === "error" && (
        <div className="issueStatus" role="alert">
          <p className="issueStatusTitle">تعذّر تحميل العدد {id}</p>
          <p>
            قد يكون هناك خلل مؤقت في الاتصال. يمكنك إعادة المحاولة، أو العودة إلى
            قائمة الأعداد.
          </p>
          <div className="issueStatusActions">
            <Button
              variant="primary"
              onClick={() => setRetryCount((count) => count + 1)}
            >
              إعادة المحاولة
            </Button>
            <Link className="issueNumber" to="/browse">
              تصفّح الأعداد
            </Link>
          </div>
        </div>
      )}

      {status === "ready" && (
        <div>
          <div
            id="menue"
            className={"menu " + menuA}
            onClick={() => {
              menuAct();
            }}
          >
            <Bookmarks />
          </div>
          {/* Scoped to the toolbar only. These buttons live outside <Viewer>, so
              the Viewer's own `localization` prop never reaches them and they kept
              their English accessible names. The provider deliberately does not
              wrap the viewer subtree — the viewer manages its own localization
              state, and wrapping it stops the document from loading at all. */}
          <LocalizationContext.Provider value={localizationValue}>
            <div className="readerBar">
              {/* <span className="issueNumber">العدد: {id}</span> */}

              <Link className="issueNumber prev" to={{ pathname: prev }}>
                {"<< "}العدد السابق
              </Link>

              <EnterFullScreenButton />
              <ZoomOutButton />
              <ZoomPopover />
              <ZoomInButton />
              <div className="hideOnMobile" style={{ padding: "0px 2px" }}>
                <ShowSearchPopoverButton className="hideOnMobile" />
              </div>


              <div className="hideOnMobile" style={{ padding: "0px 2px" }}>
                <SwitchScrollModeButton mode={ScrollMode.Vertical} />
              </div>
              <div className="hideOnMobile" style={{ padding: "0px 2px" }}>
                <SwitchScrollModeButton mode={ScrollMode.Horizontal} />
              </div>
              <span
                className="issueNumber TOCButton"
                onClick={() => {
                  menuAct();
                }}
              > فهرس العدد
              </span>
              {/* The transcribed text pages under /archive/ are deliberately
                  NOT linked from the reader. They exist so search engines can
                  index the archive's contents, and they are discovered through
                  sitemap.xml rather than through the interface.

                  Note this hides the path, not the content: an indexed page is
                  a publicly readable one, so anyone arriving from a search
                  result can still read the text. Making it genuinely private
                  would mean removing it from the sitemap and adding noindex,
                  which would also remove the reason it exists. */}
              <Link className="issueNumber next" to={{ pathname: next }}>
                العدد التالي{" >>"}
              </Link>

            </div>
          </LocalizationContext.Provider>

          <div
            className="pagePane"
            style={{
              border: "1px solid rgba(0, 0, 0, 0.3)",
              height: "80vh",
              margin: "0.5%",
            }}
          >
            <Container
              fluid
              style={{
                height: "100%",
                justifyContent: "center",
              }}
            >
              <Row
                style={{
                  justifyContent: "center",
                  height: "100%",
                  backgroundColor: "#fbfbfbdd",
                  padding: "0px",
                }}
              >
                <Col
                  style={{ height: "100%", padding: "0px" }}
                  className="d-none d-lg-block"
                  xs="0"
                  lg="3"
                >
                  <Bookmarks />
                </Col>
                <Col
                  xs="0"
                  lg="9"
                  style={{ padding: "0px", height: "100%" }}
                  onClick={() => {
                    menuAct("hide");
                  }}
                >
                  {/* Must be same-origin: browsers refuse to construct a Worker
                      from a cross-origin script, which silently prevents pdf.js
                      from ever starting. Copied into public/ by prestart/prebuild. */}
                  <Worker
                    workerUrl={process.env.PUBLIC_URL + "/pdf.worker.min.js"}
                  >
                    {/* fileUrl points at the already-downloaded blob, so the
                        viewer never has to re-request an expired signed URL. */}
                    {/* Fit to width. PageFit shrank a broadsheet to about 61%,
                        too small to read; fitting the width keeps the type
                        legible and lets the reader scroll down the page. */}
                    <Viewer
                      fileUrl={pdfObjectUrl}
                      defaultScale={SpecialZoomLevel.PageWidth}
                      localization={viewerLocalizationAr}
                      plugins={plugins}
                    />
                  </Worker>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      )}
    </div>
  );
}

/*
 * Placeholder until the search index is in place. The redesign puts search front
 * and centre on the home page, so this route has to exist and say something
 * truthful rather than fall through to the 404 page.
 */
function Search() {
  const { search } = useLocation();
  const term = new URLSearchParams(search).get("q") || "";

  usePageMeta(
    term ? "جريدة الإيمان - نتائج البحث عن " + term : "جريدة الإيمان - البحث"
  );

  return (
    <div className="pageWrap">
      <div className="sectionHead">
        <h2>البحث</h2>
      </div>
      <div className="panel" style={{ textAlign: "center" }}>
        {term && (
          <p style={{ fontSize: "1.1rem" }}>
            البحث عن: <strong>{term}</strong>
          </p>
        )}
        <p>
          البحث في نصوص الأعداد قيد الإعداد. حتى ذلك الحين يمكنك تصفح الأعداد
          مرتبة بالسنوات، أو استخدام فهرس المقالات لكل سنة.
        </p>
        <div className="issueStatusActions">
          <Link className="btnGhost" to="/browse">
            تصفح الأعداد
          </Link>
        </div>
      </div>
    </div>
  );
}

function NoMatch() {
  usePageMeta("جريدة الإيمان - الصفحة غير موجودة");

  // Previously an untranslated "No match for /path" on an otherwise Arabic site.
  return (
    <div className="issueStatus" role="alert">
      <p className="issueStatusTitle">الصفحة غير موجودة</p>
      <p>لم نتمكّن من العثور على الصفحة المطلوبة.</p>
      <div className="issueStatusActions">
        <Link className="btnGhost" to="/browse">
          تصفح الأعداد
        </Link>
        <Link className="issueNumber" to="/">
          الصفحة الرئيسية
        </Link>
      </div>
    </div>
  );
}
